const VERSION: string = '0.1.0-staging.21601';
export default VERSION;
